var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "listsocialaccount",
                attrs: {
                  mode: "remote",
                  title: "List of Faild Post",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-selected-rows-change": _vm.selectionChanged,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c("div", { staticClass: "table-action" }, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-eye btn edit-btn-vvg waves-effect",
                                      attrs: {
                                        title: "View Faild Post",
                                        "aria-hidden": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.viewFailedPost(
                                            props.row.sid
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn edit-btn-vvg waves-effect",
                                        attrs: {
                                          title: "Post Again",
                                          id: "delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.postAgain([props.row])
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-paper-plane",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              props.column.field == "media_type"
                                ? _c(
                                    "div",
                                    [
                                      props.row.media_type != null
                                        ? [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.capitalizeFirstLetter(
                                                    props.row.media_type
                                                  )
                                                ) +
                                                "\n                              "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    }),
                    {
                      key: "selected-row-actions",
                      fn: function(computed) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(computed.selectedRows) +
                              "\n                        "
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                title: "Post Again",
                                id: "deleteMultiple"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.postAgain(
                                    _vm.$refs["listsocialaccount"].selectedRows
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Post Again (" + _vm._s(_vm.selectedRows) + ")"
                              )
                            ]
                          )
                        ])
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Failed Posts")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04f3df00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f3df00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/FailedPost.vue
// module id = null
// module chunks = 